(ns com.theplantscape.svg-generation.filters
  (:require
   [com.theplantscape.svg-generation.compat
    :refer
    [base-frequency
     num-octaves
     std-deviation
     x-channel-selector
     y-channel-selector]]))

;; https://www.smashingmagazine.com/2015/05/why-the-svg-filter-is-awesome/
;; https://css-tricks.com/creating-patterns-with-svg-filters/
;; https://www.linkedin.com/pulse/26-images-you-wont-believe-were-created-only-svg-bence-szab%C3%B3

(def tree-filter
  [:filter#tree-filter {:width "150%" :height "150%"}
   ["feTurbulence"
    (-> {:type "turbulence" :result "turbulence"}
        (base-frequency "0.15")
        (num-octaves "6"))]
   ["feDisplacementMap"
    (-> {:in2 "turbulence" :in "SourceGraphic" :scale "5"}
        (x-channel-selector "R")
        (y-channel-selector "G"))]])

(def bush-filter
  [:filter#bush-filter {:width "150%" :height "150%"}
   ["feTurbulence"
    (-> {:type "turbulence" :result "turbulence"}
        (base-frequency "0.20")
        (num-octaves "3"))]
   ["feDisplacementMap"
    (-> {:in2 "turbulence" :in "SourceGraphic" :scale "1"}
        (x-channel-selector "R")
        (y-channel-selector "G"))]])

(def ground-filter
  [:filter#ground-filter {:width "150%" :height "150%"}
   ["feTurbulence"
    (-> {:type "turbulence" :result "turbulence"}
        (base-frequency "0.85")
        (num-octaves "8"))]
   ["feDisplacementMap"
    (-> {:in2 "turbulence" :in "SourceGraphic" :scale "0.25"}
        (x-channel-selector "R")
        (y-channel-selector "G"))]])

(def leaf-filter
  [:filter#bush-filter
   ["feTurbulence"
    (-> {:type "fractalNoise"}
        (base-frequency "0.06")
        (num-octaves "3"))]
   ["feComponentTransfer"
    ["feFuncR" {:type "discrete" :tablevalues "0 0 0"}]
    ["feFuncG" {:type "discrete" :tablevalues "0 0 0 1 0"}]
    ["feFuncB" {:type "discrete" :tablevalues "0 0"}]]
   ["feColorMatrix" {:values "1  0 0 0 0
                              -1  1 0 0 0
                              -1 -1 1 0 0
                               0  0 0 0 1"}]
   ["feColorMatrix" {:values "0  .42  0 0 .08
                               0  .35 0 0 .17
                               0  .15 0 0 .08
                                0    0     0    0 1"}]])

(def hedge-filter
  [:filter#hedge-filter
   ["feTurbulence"
    (-> {:seed 4 :type "fractalNoise" :result "turbulence"}
        (num-octaves 5)
        (base-frequency "0.4"))]
   ["feDisplacementMap"
    (->
     {:in2 "turbulence" :in "SourceGraphic" :scale "30"}
     (x-channel-selector "G")
     (y-channel-selector "R"))]])

(def goo-filter
  [:filter#goo-filter
   ["feGaussianBlur"
    (-> {:in "SourceGraphic" :result "blur"}
        (std-deviation "8"))]
   ["feColorMatrix" {:in "blur" :type "matrix" :values
                     "1 0 0 0 0
                    0 1 0 0 0
                    0 0 1 0 0
                    0 0 0 12 -8"
                     :result "goo"}]
   #_["feBlend" {:in "SourceGraphic" :in2 "goo"}]
   ["feComposite" {:in "SourceGraphic" :in2 "goo" :operator "atop"}]])

(def hatch-filter 
  [:filter#hatch-filter {:x "0%" :y "0%" :width "50px" :height "10px"}
   ["feTurbulence" {:type "fractalNoise" "baseFrequency" "0.30 8.00" "numOctaves" "2" :result "noise2"}]
   ["feComponentTransfer" {:in "noise2" :result "comp"}
    ["feFuncR" {:type "table" "tableValues" "0 1 1 0"}]
    ["feFuncB" {:type "table" "tableValues" "0 1 1 0"}]
    ["feFuncG" {:type "table" "tableValues" "0 1 1 0"}]
    ["feFuncA" {:type "table" "tableValues" "1 1 1 0.75 0.2 0.75 1 1 1 1"}]]
   ;;["feGaussianBlur" (-> {:in "noise2" :result "blur1"} (std-deviation "1.1 0.2"))]
   ["feGaussianBlur" (-> {:in "comp" :result "blur2"} (std-deviation "0.12 0.2"))]
   ["feBlend" {:mode "darken" :in "comp" :in2 "blur2" :result "blend"}]
   ;;feConvolveMatrix causes issues with batik generation
   #_[:feConvolveMatrix {:in "comp" :order "3" :kernelMatrix
                       "-1 2 -1
                       -1 1 -1
                       -1 2 -1"
                       :result "conv"}]
   [:feComposite {:operator "in" :in "SourceGraphic" :in2 "blend" :result "overlay"}]])

(def filters
  [:defs
   hatch-filter
   hedge-filter
   tree-filter
   goo-filter
   bush-filter
   ground-filter])
